<script setup lang="ts">
import type { IProps } from './Source.types.ts'
defineProps<IProps>()
</script>

<template>
  <div class="source">
    <a
      class="source--link"
      :href="link"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ text }}

      <img
        class="source--img"
        width="16px"
        height="22px"
        :alt="$t('strategy.keyPolicies.e.source.text')"
        src="/icons/icon-external-link.svg"
      >
    </a>
  </div>
</template>

<style lang="scss" scoped>
.source {
  flex: 100%;
  align-self: center;
  margin-top: 3.2rem;
  text-align: center;

  @include body-4;

  &--link {
    @include body-2;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  &--img {
    margin-left: 0.8rem
  }
}

@include atM {
  .source {
    align-self: flex-end;
    margin-top: 1.6rem;
    text-align: right;
  }
}
</style>
